@if (loading()) {
  <app-progress-spinner class="app-icon-button__progress-spinner" />
} @else {
  <ng-content />
}
